<template>
    <div class="container content-space-1">
        <div 
            v-if="$validateText(slice.primary.header)"
            class="align-self-start"
            v-html="$prismic.asHtml(slice.primary.header)"
        />
        <div class="row">
            <input-form 
                :is-car-calculator="isCarCalculator"
                :is-fixed-amount="isFixedAmount"
                :initial-input-values="values"
                :min-max-values="minMaxValues"
                :car-cost-label="carCostLabel"
                @changed="updateValues" 
            />
            <overview 
                :amount="values.amount" 
                :duration="values.duration" 
                :interest-rate="values.interestRate" 
                :setup-fee="values.arrangementFee" 
                :invoice-fee="values.invoiceFee"
                :is-car-calculator="isCarCalculator"
            />
        </div>
        <div class="row mt-5">
            <details-table 
                :amount="values.amount" 
                :duration="values.duration" 
                :interest-rate="values.interestRate" 
                :arrangement-fee="values.arrangementFee" 
                :invoice-fee="values.invoiceFee"
            />
        </div>
        <highlighted-lenders 
            v-if="showHighlightedLenders"
            :loan-amount="values.amount" 
            :duration="values.duration" 
            :alternate-data-config="alternateDataConfig"
        />
    </div>
</template>
<script>
import InputForm from '@/components/calculator/InputForm.vue';
import Overview from '@/components/calculator/Overview.vue';
import DetailsTable from '@/components/calculator/DetailsTable.vue';
import HighlightedLenders from '@/components/calculator/HighlightedLenders.vue';

export default {
    components: {
        InputForm,
        Overview,
        DetailsTable,
        HighlightedLenders
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    data() {
        const isCarCalculator = this.slice.primary.loan_type === 'car_loan';
        const defaultAmount = isCarCalculator ? 150000 : 10000;
        const initialAmount = this.slice.primary.initial_amount || defaultAmount;
        const initialDownPayment = this.slice.primary.initial_down_payment || 20;

        const defaultMaxAmount = this.$isSpain() ? 60000 
            : isCarCalculator ? 1000000
            : 600000;

        const settings = this.$store.state.settings;
        const defaultDuration = settings?.calculator_default_duration || 12;

        const carCostLabel = this.$validateText(this.slice.primary.car_cost_input_label) 
            ? this.slice.primary.car_cost_input_label 
            : this.$translate('calculator_car_cost', 'Bilens kostnad');

        const values = {
            amount: initialAmount,
            carCost: initialAmount / (1 - initialDownPayment/100),
            downPayment: initialDownPayment,
            duration: this.slice.primary.initial_duration || defaultDuration,
            interestRate: this.slice.primary.initial_interest || 12,
            arrangementFee: 0,
            invoiceFee: 0,
        };
        const minMaxValues = {
            minAmount: this.slice.primary.min_amount || (this.$isSpain() ? 50 : 1000),
            maxAmount: this.slice.primary.max_amount || defaultMaxAmount,
            minDuration: this.slice.primary.min_duration || 1,
            maxDuration: this.slice.primary.max_duration || 180,
            minInterest: this.slice.primary.min_interest || 0,
            maxInterest: this.slice.primary.max_interest || 50,
            minDownPayment: this.slice.primary.min_down_payment || 20,
            maxDownPayment: Math.min((this.slice.primary.max_down_payment || 80), 99)
        };
        return {
            values,
            minMaxValues,
            isCarCalculator: isCarCalculator,
            isFixedAmount: this.slice.primary.is_fixed_amount,
            carCostLabel,
            showHighlightedLenders: this.slice.primary.show_highlighted_lenders
        };
    },
    computed: {
        alternateDataConfig() {
            return this.$getAlternateDataConfig(this.slice);
        }
    },
    methods: {
        updateValues(allValues) {
            this.values.amount = allValues.amount;
            this.values.carCost = allValues.carCost;
            this.values.downPayment = allValues.downPayment;
            this.values.duration = allValues.duration;
            this.values.interestRate = allValues.interestRate;
            this.values.arrangementFee = allValues.arrangementFee;
            this.values.invoiceFee = allValues.invoiceFee;
        }
    }
};
</script>